import {Component} from '@angular/core';

@Component({
  selector: 'fax-node',
  templateUrl: './fax-node.component.html'
})
export class FaxNodeComponent {
    node
}
